import * as React from 'react';
import {getSystem, getMeta, TypeImplementation} from '@packages/systems/wfdl';
import {
  type ContextualExpression,
  ContextualExpressions,
  stripAnn,
  getAnn,
} from '@packages/utilities/contextual-expression';
import {
  ExpressionEditor,
  useExpressionEditorContext,
  updateExpressionAction,
} from '@packages/systems/ExpressionEditor-utils';
import {qualify, pluginName, iconName} from '@packages/systems/wfdl-Qualified';
import Textarea from '@packages/systems/design-system/Textarea';

import {TText, EText} from '@packages/systems/wfdl-ast';
import {InterpolatedText} from '@packages/systems/ui/shared-ui/InterpolatedText';

export const MultilineTextType = TypeImplementation.Alias({
  type: TText,
  render: function RenderMultiLineText({
    expr,
    dispatch,
  }: {
    expr: ContextualExpression;
    dispatch: TypeImplementation.ExpressionEditorDispatch;
  }) {
    const strippedExpr = stripAnn(expr);
    const eeContext = useExpressionEditorContext();
    const [value, setValue] = React.useState(
      ContextualExpressions.getText(strippedExpr)
    );
    const onBlur = React.useCallback(() => {
      dispatch(updateExpressionAction(EText(value || '')));
    }, [dispatch, value]);

    // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    const onChange = React.useCallback((e) => {
      setValue(e.target.value);
    }, []);

    if (eeContext === 'logic') {
      const dataType = getAnn(expr).type;
      const label = dataType ? getSystem(dataType)?.label : null;
      const placeholder = dataType ? getMeta(dataType)?.placeholder : null;
      return (
        <InterpolatedText
          expr={expr}
          onExpressionChange={(newExpression) =>
            dispatch(updateExpressionAction(newExpression))
          }
          multiLine
          placeholder={placeholder || ''}
          label={label || ''}
        />
      );
    }

    if (value) {
      return <Textarea text={value} onChange={onChange} onBlur={onBlur} />;
    }

    return <ExpressionEditor dispatch={dispatch} expression={expr} />;
  },
  icon: TypeImplementation.IconByName(
    qualify(pluginName('Basic'), iconName('Text'))
  ),
});
